module.exports = __webpack_public_path__ + "static/media/box.98be15a3.svg";